// extracted by mini-css-extract-plugin
export default {"headerStickyObserver":"sticky_headerStickyObserver__ZzTkb","headerSticky":"sticky_headerSticky__DGTep"};